import api, { unwrap } from './client'
import type { PaginatedProjects, Project } from '@/types/models'

export const projectsApi = {
  // Same endpoint the dashboard SPA's project list uses. The picker only
  // needs the first page — there's no pagination UI here.
  async listProjects(): Promise<PaginatedProjects> {
    const { data } = await api.get<PaginatedProjects>('/projects')
    return data
  },

  updateProject(id: string, payload: Pick<Project, 'linear_auto_run_enabled'>): Promise<Project> {
    return unwrap(api.patch<{ data: Project }>(`/projects/${id}`, payload))
  },
}
